import { useContext, useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';

const useWarehouseOrderInvoicingService = () => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { doGet, doPut } = useFetch();

    const [fetchingEditWarehouseOrderInvoicing, setFetchingEditWarehouseOrderInvoicing] = useState(false);
    const [fetchingWarehouseOrderInvoicingByWarehouseOrder, setFetchingWarehouseOrderInvoicingByWarehouseOrder] = useState(false);

    const editWarehouseOrderInvoicing = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.QUOTE_INVOICING.EDIT_QUOTE_INVOICING.replace(':id', id.toString()),
            setFetching: setFetchingEditWarehouseOrderInvoicing
        });
    };

    const getWarehouseOrderInvoicingByWarehouseOrder = (
        quoteId: number,
        mode: 'view' | 'edit' = 'view', // modo opcional
        events: ServiceEvents = {}
    ) => {
        const url = `${EndPoints.QUOTE_INVOICING.GET_QUOTE_INVOICING_BY_QUOTE.replace(':id', quoteId.toString())}?mode=${mode}`;

        doGet({
            ...events,
            url,
            setFetching: setFetchingWarehouseOrderInvoicingByWarehouseOrder
        });
    };

    return {
        editWarehouseOrderInvoicing,
        getWarehouseOrderInvoicingByWarehouseOrder,
        fetchingEditWarehouseOrderInvoicing,
        fetchingWarehouseOrderInvoicingByWarehouseOrder
    };
};

export default useWarehouseOrderInvoicingService;
